// Campus photo for /colleges/cuny-hunter-college: CC BY 4.0, by Kenneth C. Zirkel, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AHunter_College_North_Building.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/cuny-hunter-college/; credited under the photo.
const photo = {
    "slug": "cuny-hunter-college",
    "alt": "Entrance to the North Building of Hunter College on the Upper East Side of Manhattan, New York",
    "src": "/colleges/cuny-hunter-college/campus-1600.webp",
    "srcSmall": "/colleges/cuny-hunter-college/campus-800.webp",
    "srcMid": "/colleges/cuny-hunter-college/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/cuny-hunter-college/og.jpg",
    "title": "Hunter College North Building",
    "author": "Kenneth C. Zirkel",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AHunter_College_North_Building.jpg",
    "read": "2026-10-01"
};

export default photo;
